import {
  GET_GUESTS,
  GET_GUESTS_FAIL,
  GET_GUESTS_SUCCESS,
  GET_GUEST_DETAIL,
  ADD_NEW_GUEST,
  ADD_GUEST_SUCCESS,
  ADD_GUEST_FAIL,
  UPDATE_GUEST,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_FAIL,
  GET_GUEST_DETAIL_FAIL,
  GET_GUEST_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_GUEST,
  DELETE_GUEST_SUCCESS,
  DELETE_GUEST_FAIL,
  UPDATE_GUEST_ACCESS,
  UPDATE_GUEST_ACCESS_SUCCESS,
  UPDATE_GUEST_ACCESS_FAIL,
  GET_EXPORT_GUEST,
  GET_EXPORT_GUEST_SUCCESS,
  GET_EXPORTED_GUEST_FAIL,
  RESET_EXPORT_DATA,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST,
  GUEST_COMPLIMENTARY_ACCESS_GRANT,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS,
  GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL,
  GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL,
} from "./actionTypes"

export const guestComplimentaryAccessRequest = payload => ({
  type: GUEST_COMPLIMENTARY_ACCESS_REQUEST,
  payload,
});

export const guestComplimentaryAccessGrant = payload => ({
  type: GUEST_COMPLIMENTARY_ACCESS_GRANT,
  payload,
});

export const getGuests = payload => ({
  type: GET_GUESTS,
  payload,
})

export const getGuestsSuccess = guests => ({
  type: GET_GUESTS_SUCCESS,
  payload: guests,
})

export const addNewGuest = guest => ({
  type: ADD_NEW_GUEST,
  payload: guest,
})

export const addGuestSuccess = guest => ({
  type: ADD_GUEST_SUCCESS,
  payload: guest,
})

export const addGuestFail = error => ({
  type: ADD_GUEST_FAIL,
  payload: error,
})

export const updateGuest = guest => ({
  type: UPDATE_GUEST,
  payload: guest,
})

export const updateGuestSuccess = guest => ({
  type: UPDATE_GUEST_SUCCESS,
  payload: guest,
})

export const updateGuestFail = error => ({
  type: UPDATE_GUEST_FAIL,
  payload: error,
})

export const getGuestsFail = error => ({
  type: GET_GUESTS_FAIL,
  payload: error,
})

export const getGuestDetail = GuestId => ({
  type: GET_GUEST_DETAIL,
  GuestId,
})

export const getGuestDetailSuccess = GuestDetails => ({
  type: GET_GUEST_DETAIL_SUCCESS,
  payload: GuestDetails,
})

export const getGuestDetailFail = error => ({
  type: GET_GUEST_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})

export const deleteGuest = guest => ({
  type: DELETE_GUEST,
  payload: guest,
})

export const deleteGuestSuccess = guest => ({
  type: DELETE_GUEST_SUCCESS,
  payload: guest,
})

export const deleteGuestFail = error => ({
  type: DELETE_GUEST_FAIL,
  payload: error,
})

export const updateGuestAccess = guest => ({
  type: UPDATE_GUEST_ACCESS,
  payload: guest,
})

export const updateGuestAccessSuccess = guest => ({
  type: UPDATE_GUEST_ACCESS_SUCCESS,
  payload: guest,
})

export const updateGuestAccessFail = error => ({
  type: UPDATE_GUEST_ACCESS_FAIL,
  payload: error,
})

export const getExportGuest = payload => ({
  type: GET_EXPORT_GUEST,
  payload,
})

export const getExportGuestSuccess = SessionTicket => ({
  type: GET_EXPORT_GUEST_SUCCESS,
  payload: SessionTicket,
})

export const getExportGuestFail = error => ({
  type: GET_EXPORTED_GUEST_FAIL,
  payload: error,
})

export const guestComplimentaryAccessRequestSuccess = status => ({
  type: GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS,
  payload: status,
})

export const guestComplimentaryAccessGrantSuccess = status => ({
  type: GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL,
  payload: status,
})

export const guestComplimentaryAccessRequestFail = error => ({
  type: GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS,
  payload: error,
})

export const guestComplimentaryAccessGrantFail = error => ({
  type: GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL,
  payload: error,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})
